<template>
   <app-master>

    <div slot='breadcrumb'>
        <app-breadcrumb>
             <div class="title-box text-left">
                  <div class="page-title-heading">
                      <h1 class="title">About Us</h1>
                  </div><!-- /.page-title-captions -->
                  <div class="breadcrumb-wrapper">
                      <span>
                          <router-link to="/" tag="a" > <i class="ti ti-home"></i>&nbsp;&nbsp;Home </router-link>
                      </span>
                      <span class="ttm-bread-sep ttm-textcolor-white">&nbsp;   →  &nbsp;</span>
                      <span class="ttm-textcolor-skincolor">About Us</span>
                  </div>  
              </div>
        </app-breadcrumb>
    </div>



      <div slot="main-content">



          <!-- aboutus-section -->
            <section class="ttm-row second-about-section bg-img1 position-relative clearfix">
                <div class="container">
                    <div class="row"><!-- row -->
                        <div class="col-lg-6">
                            <!-- ttm_single_image-wrapper -->
                            <div class="ttm_single_image-wrapper after-border style2 position-relative ml-20">
                                <img class="img-fluid border-12px-solid white-border" src="/img/who.jpg" title="single-img-five" alt="single-img-five">
                            </div><!-- ttm_single_image-wrapper end -->
                        </div>
                        <div class="col-lg-6">
                            <div class="res-991-mt-50">
                                <!-- section title -->
                                <div class="section-title clearfix">
                                    <div class="title-header">
                                        <h5>About The Company</h5>
                                        <h2 class="title">Who We Are</h2>
                                    </div>
                                    <div class="heading-seperator">
                                        <span></span>
                                    </div>
                                </div><!-- section title end -->
                                <p>Nardus Company Ltd are a global supplier of Essential Oils into the Flavour, Fragrance and Cosmetic industries. Nardus offer customers an extensive line of essential oils and lemongrass-based domestic products.</p>
                                <p>Headquartered in Lagos, Nigeria, we support the worldwide production and distribution of the finest Essential Oils, Spice Oleoresins, Herbal Extracts, Hydrosols and other naturally formulated homecare products.</p>
                                <p> Apart from manufacturing many of our products ourselves, our volume purchases through our Central Purchasing System enable us to offer the largest selection of pure essential oils at affordable prices. We have a wide variety of pack sizes to meet all your specific needs, large, small, or anywhere between. </p>
                                <!-- <div class="row ttm-bgcolor-white align-items-center mt-30"> -->
                                    <!-- <div class="col-md-4 col-lg-4"> -->
                                        <!--ttm-fid-->
                                        <!-- <div class="ttm-fid inside without-icon style1">
                                            <div class="ttm-fid-contents text-center"> -->
                                                <!--ttm-fid-contents-->
                                                <!-- <h4 class="ttm-fid-inner">
                                                    <span   data-appear-animation = "animateDigits"
                                                    data-from             = "0"
                                                    data-to               = "35"
                                                    data-interval         = "2"
                                                    data-before           = ""
                                                    data-before-style     = "sup"
                                                    data-after            = "+"
                                                    data-after-style      = "sub"
                                                >35</span><span class="ml-5">+</span>
                                                </h4>
                                                <h3 class="ttm-fid-title">Our Team</h3> -->
                                                <!--ttm-fid-title-->
                                            <!-- </div>
                                        </div> -->
                                        <!-- ttm-fid end-->
                                    <!-- </div> -->
                                    <!-- <div class="col-md-4 col-lg-4"> -->
                                        <!--ttm-fid-->
                                        <!-- <div class="ttm-fid inside  without-icon style1">
                                            <div class="ttm-fid-contents text-center"> -->
                                                <!--ttm-fid-contents-->
                                                <!-- <h4 class="ttm-fid-inner">
                                                    <span   data-appear-animation = "animateDigits"
                                                    data-from             = "0"
                                                    data-to               = "75"
                                                    data-interval         = "2"
                                                    data-before           = ""
                                                    data-before-style     = "sup"
                                                    data-after            = "+"
                                                    data-after-style      = "sub"
                                                >75</span><span class="ml-5">+</span>
                                                </h4>
                                                <h3 class="ttm-fid-title">Our Shop</h3> -->
                                                <!--ttm-fid-title-->
                                            <!-- </div>
                                        </div> -->
                                        <!-- ttm-fid end-->
                                    <!-- </div> -->
                                    <!-- <div class="col-md-4 col-lg-4"> -->
                                        <!--ttm-fid-->
                                        <!-- <div class="ttm-fid inside without-icon style1">
                                            <div class="ttm-fid-contents text-center"> -->
                                                <!--ttm-fid-contents-->
                                                <!-- <h4 class="ttm-fid-inner">
                                                    <span   data-appear-animation = "animateDigits"
                                                    data-from             = "0"
                                                    data-to               = "150"
                                                    data-interval         = "2"
                                                    data-before           = ""
                                                    data-before-style     = "sup"
                                                    data-after            = "+"
                                                    data-after-style      = "sub"
                                                >150</span><span class="ml-5">+</span>
                                                </h4>
                                                <h3 class="ttm-fid-title">Our Brand</h3> -->
                                                <!--ttm-fid-title-->
                                            <!-- </div>
                                        </div> -->
                                        <!-- ttm-fid end-->
                                    <!-- </div> -->
                                <!-- </div> -->
                                <div class="row mt-30">
                                    <div class="col-md-4 col-lg-4 col-sm-4">
                                        <div class="text-left pt-15">
                                            <img src="https://via.placeholder.com/145X60/444444.png" alt="about-sign">
                                        </div>
                                    </div>
                                    <div class="col-md-8 col-lg-8 col-sm-8">
                                        <!--  featured-icon-box --> 
                                        <div class="featured-icon-box without-icon style1 text-left pt-15">
                                            <div class="featured-content"><!--  featured-content -->
                                                <div class="featured-desc"><!--  featured-desc -->
                                                    <p>Call to ask any question</p>
                                                </div>
                                                <div class="featured-title"><!--  featured-title -->
                                                    <h5>+234 906-282-2260</h5>
                                                </div>
                                            </div>
                                        </div><!--  featured-icon-box END -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- aboutus-section end -->

            <!-- progress-section -->
            <section class="ttm-row zero-padding-section position-relative z-1 clearfix">
                <div class="container">
                    <div class="row no-gutters"><!-- row -->
                        <div class="col-lg-6">
                            <!-- col-img-img-one -->
                            <div class="col-bg-img-one ttm-col-bgimage-yes ttm-bg ttm-col-bgcolor-yes ttm-bgcolor-darkgrey ttm-left-span">
                                <div class="ttm-col-wrapper-bg-layer ttm-bg-layer">
                                    <div class="ttm-bg-layer-inner"></div>
                                </div>
                                <div class="layer-content">
                                    <div class="spacing-2 ">
                                        <!-- section title -->
                                        <div class="section-title clearfix">
                                            <div class="title-header">
                                                <h5>Why Choose Us?</h5>
                                                <!-- <h2 class="title">Our Vegan has 35 year experience in Agriculture</h2> -->
                                            </div>
                                            <div class="heading-seperator">
                                                <span></span>
                                            </div>
                                        </div><!-- section title end -->
                                        <p>Our level of professionalism, integrity and tact sets us in a class of our own. We operate in a facility that houses state-of-the-art equipment for blending, filtration and packaging.</p>
                                        <div class="section-title clearfix">
                                            <div class="title-header">
                                                <h5>Objectives</h5>
                                            </div>
                                            <div class="heading-seperator">
                                                <span></span>
                                            </div>
                                        </div>
                                        <!-- <div class="mt-40"> -->
                                            <!-- progress-bar -->
                                            <div class="ttm-progress-bar" data-percent="90%">
                                                <div class="progress-bar-title">To make a significant contribution to the world's need of essential oils</div><!-- progress-bar-title -->
                                                <div class="progress-bar-inner">
                                                    <div class="progress-bar progress-bar-color-bar_skincolor"></div>
                                                </div>
                                                <!-- <div class="progress-bar-percent" data-percent="90">90%</div> -->
                                                <!-- progress-bar-percent -->
                                            </div>
                                            <!-- progress-bar END -->
                                            <!-- progress-bar -->
                                            <div class="ttm-progress-bar" data-percent="80%">
                                                <div class="progress-bar-title">To support health and wellbeing through alternative medicine from plant extracts</div><!-- progress-bar-TITLE -->
                                                <div class="progress-bar-inner">
                                                    <div class="progress-bar progress-bar-color-bar_skincolor"></div>
                                                </div>
                                                <!-- <div class="progress-bar-percent" data-percent="80">80%</div> -->
                                                <!-- progress-bar-PERCENT -->
                                            </div>
                                            <!-- progress-bar END -->
                                            <!-- progress-bar -->
                                            <div class="ttm-progress-bar" data-percent="90%">
                                                <div class="progress-bar-title">To constantly research and source new products that meet our customers’ growing needs</div><!-- progress-bar-TITLE -->
                                                <div class="progress-bar-inner">
                                                    <div class="progress-bar progress-bar-color-bar_skincolor"></div>
                                                </div>
                                                <!-- <div class="progress-bar-percent" data-percent="90">90%</div> -->
                                                <!-- progress-bar-PERCENT -->
                                            </div>
                                            <!-- progress-bar END -->
                                        <!-- </div> -->
                                    </div>
                                </div>
                            </div>
                            <!-- col-img-img-one -->
                        </div>
                        <div class="col-lg-6 mt_40 mb_40 res-991-m-0">
                            <!-- col-img-img-two -->
                            <div class="col-bg-img-two ttm-col-bgimage-yes ttm-bg ttm-right-span border40-img skincolor-border res-991-d-none">
                                <div class="ttm-col-wrapper-bg-layer ttm-bg-layer">
                                </div>
                                <div class="layer-content"></div>
                            </div>
                            <!-- col-img-img-two responsive-img-->
                            <img src="https://via.placeholder.com/946X603/444444.jpg" class="ttm-equal-height-image" alt="bg-image">
                        </div>
                    </div><!-- row -->
                </div>
            </section>
            <!-- progress-section -->

           

            <!-- only-text-section -->
            <section class="ttm-row only-text-section ttm-bgcolor-skincolor ttm-bg ttm-bgimage-yes bg-img10 clearfix">
                <div class="ttm-row-wrapper-bg-layer ttm-bg-layer"></div>
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="d-md-flex justify-content-md-between align-items-md-center">
                                <!--  featured-icon-box --> 
                                <div class="featured-icon-box left-icon icon-align-top">
                                    <div class="featured-icon"><!--  featured-icon --> 
                                        <!-- <div class="ttm-icon ttm-icon_element-color-white ttm-icon_element-size-lg">
                                            <i class="flaticon flaticon-agriculture"></i> -->
                                            <!--  ttm-icon --> 
                                        <!-- </div> -->
                                    </div>
                                    <div class="featured-content"><!--  featured-content -->
                                        <!-- <div class="featured-desc"> -->
                                            <!--  featured-desc -->
                                            <!-- <p>AGROTEK SPECIAL OFFERS</p>
                                        </div> -->
                                        <div class="featured-title"><!--  featured-title -->
                                            <h5 class="fs-30">Talk to Our Support Team</h5>
                                        </div>
                                    </div>
                                </div><!--  featured-icon-box END -->
                                <div class="">
                                    <router-link to="/contact" tag="a" class="ttm-btn ttm-btn-size-md ttm-btn-style-border ttm-btn-color-white res-767-mt-20"> Contact Us </router-link>
                                    <!-- <a href="#" class="ttm-btn ttm-btn-size-md ttm-btn-style-border ttm-btn-color-white res-767-mt-20"> Contact Us</a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- only-text-section -->

            <!-- fid-section -->
            <section class="ttm-row zero-padding-section position-relative z-1 clearfix">
                <div class="container">
                    <div class="row ttm-bgcolor-grey border-12px-solid white-border mt_80 no-gutters"><!-- row -->
                        <div class="col-md-6 col-sm-6 col-lg-3">
                            <!--ttm-fid-->
                            <div class="ttm-fid inside ttm-fid-view-lefticon style3">
                                <div class="ttm-fid-left"><!--ttm-fid-left-->
                                    <div class="ttm-fid-icon-wrapper">
                                        <i class="flaticon flaticon-farmer"></i>
                                    </div>
                                </div>
                                <div class="ttm-fid-contents text-left"><!--ttm-fid-contents-->
                                    <h4 class="ttm-fid-inner">
                                        <span   data-appear-animation = "animateDigits"
                                        data-from             = "0"
                                        data-to               = "88"
                                        data-interval         = "5"
                                        data-before           = ""
                                        data-before-style     = "sup"
                                        data-after            = ""
                                        data-after-style      = "sub"
                                    >88</span>
                                    </h4>
                                    <h3 class="ttm-fid-title">Happy Customers</h3><!--ttm-fid-title-->
                                </div>
                            </div><!-- ttm-fid end-->
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-3">
                            <!--ttm-fid-->
                            <div class="ttm-fid inside ttm-fid-view-lefticon style3">
                                <div class="ttm-fid-left"><!--ttm-fid-left-->
                                    <div class="ttm-fid-icon-wrapper">
                                        <i class="flaticon flaticon-mill"></i>
                                    </div>
                                </div>
                                <div class="ttm-fid-contents text-left"><!--ttm-fid-contents-->
                                    <h4 class="ttm-fid-inner">
                                        <span   data-appear-animation = "animateDigits"
                                        data-from             = "0"
                                        data-to               = "20"
                                        data-interval         = "5"
                                        data-before           = ""
                                        data-before-style     = "sup"
                                        data-after            = ""
                                        data-after-style      = "sub"
                                    >20</span>
                                    </h4>
                                    <h3 class="ttm-fid-title">Product Range</h3><!--ttm-fid-title-->
                                </div>
                            </div><!-- ttm-fid end-->
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-3">
                            <!--ttm-fid-->
                            <div class="ttm-fid inside ttm-fid-view-lefticon style3">
                                <div class="ttm-fid-left"><!--ttm-fid-left-->
                                    <div class="ttm-fid-icon-wrapper">
                                        <i class="flaticon flaticon-agriculture-5"></i>
                                    </div>
                                </div>
                                <div class="ttm-fid-contents text-left"><!--ttm-fid-contents-->
                                    <h4 class="ttm-fid-inner">
                                        <span   data-appear-animation = "animateDigits"
                                        data-from             = "0"
                                        data-to               = "10"
                                        data-interval         = "2"
                                        data-before           = ""
                                        data-before-style     = "sup"
                                        data-after            = ""
                                        data-after-style      = "sub"
                                    >10</span>
                                    </h4>
                                    <h3 class="ttm-fid-title">Essential Oils</h3><!--ttm-fid-title-->
                                </div>
                            </div><!-- ttm-fid end-->
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-3">
                            <!--ttm-fid-->
                            <div class="ttm-fid inside ttm-fid-view-lefticon style3">
                                <div class="ttm-fid-left"><!--ttm-fid-left-->
                                    <div class="ttm-fid-icon-wrapper">
                                        <i class="flaticon flaticon-worldwide"></i>
                                        <!-- <i class="ti ti-cup"></i> -->
                                    </div>
                                </div>
                                <div class="ttm-fid-contents text-left"><!--ttm-fid-contents-->
                                    <h4 class="ttm-fid-inner">
                                        <span   data-appear-animation = "animateDigits"
                                        data-from             = "0"
                                        data-to               = "5"
                                        data-interval         = "5"
                                        data-before           = ""
                                        data-before-style     = "sup"
                                        data-after            = ""
                                        data-after-style      = "sub"
                                    >5</span>
                                    </h4>
                                    <h3 class="ttm-fid-title">Awards</h3><!--ttm-fid-title-->
                                </div>
                            </div><!-- ttm-fid end-->
                        </div>
                    </div><!-- row -->
                </div>
            </section>
            <!-- fid-section -->


           
      </div>



   </app-master>
</template>

<script>
// @ is an alias to /src
import Master from "@/components/Master.vue";
import BreadCrumb from "@/components/BreadCrumb.vue";
import {seo} from "../Repositories/seo.js"

export default {
  name: "About",
  mixins: [seo],
  components: {
    "app-master" : Master,
    "app-breadcrumb": BreadCrumb
  },


  created(){
      this.seoMetaData('About Us', ' ');
  }

  
};

</script>
